import { categoryIdFromRequest } from '@/utils/categories';
import trackEvent from '@/client/utils/analytics/trackEvent';
import trackingKeys from '@/client/constants/analytics/trackingKeys';
import { createSavedSearch as createSavedSearchAction } from '@/client/actions/savedSearches';
import showToastNotification from '@/client/utils/showToastNotification';

export const redirectToLoginPage = () =>
  typeof window !== 'undefined' &&
  window.location.assign(`/account/login.html?target=${encodeURIComponent(window.location.href)}`);

export const createSavedSearch = async (
  xsrfToken: string,
  searchRequestObject: TSearchRequestObject,
  subscriptionPreferences: { emailEnabled: boolean; pushEnabled: boolean },
  context: {
    setIsSearchSaved: (isSearchSaved: boolean) => void;
    setSavedSearchId: (id: number) => void;
    setIsSearchSavedSuccessfully: (isSearchSavedSuccessfully: boolean) => void;
    t: (key: string) => string;
    closeToast: React.RefObject<(() => void) | null>;
    shouldShowFloatingButton: boolean;
  },
) => {
  const { setIsSearchSaved, setSavedSearchId, t, closeToast, setIsSearchSavedSuccessfully, shouldShowFloatingButton } =
    context;
  const eventLabel = `${categoryIdFromRequest(searchRequestObject)}:${searchRequestObject.searchQuery}`;
  trackEvent({
    eventAction: shouldShowFloatingButton
      ? trackingKeys.SAVE_SEARCH.EVENT_ACTION.BEGIN_EXPERIMENT
      : trackingKeys.SAVE_SEARCH.EVENT_ACTION.BEGIN,
    eventLabel,
  });

  try {
    const { id } = await createSavedSearchAction(xsrfToken, searchRequestObject, subscriptionPreferences);
    setSavedSearchId(id);
    setIsSearchSaved(true);
    setIsSearchSavedSuccessfully(true);
    trackEvent({
      eventAction: shouldShowFloatingButton
        ? trackingKeys.SAVE_SEARCH.EVENT_ACTION.SUCCESS_EXPERIMENT
        : trackingKeys.SAVE_SEARCH.EVENT_ACTION.SUCCESS,
      eventLabel,
    });
  } catch {
    setIsSearchSaved(false);
    setIsSearchSavedSuccessfully(false);
    await showToastNotification('error', t('messages.generic_error'), closeToast);
  } finally {
    if (typeof window !== 'undefined') window.scroll(0, 0);
  }
};
